export const easing = {
  ease: "ease",
  bounce: "cubic-bezier(0.095, 1.63, 0.555, 1.475)",
  slightBounce: "cubic-bezier(0.125, 1.085, 0.325, 1.080)",
};
